'use strict';

Fotobook.flyleafStyle = {
    update() {
        $('.flyleaf-page').find('.bg').find('image').attr('xlink:href', Fotobook.createStorageUrl(Fotobook.book.flyleafStyle.preview_path));
    },
};
